<template>
  <div>
    <b-row cols="1" cols-sm="12" cols-md="12" cols-lg="12">
      <b-col lg="6">
        <h1>Contact Us</h1>
        <p>For speaking engagements, new business and other inquiries, please use the form below.</p>
        <b-form @submit="send" v-if="show">
          <b-form-input v-model="form.name" placeholder="Name"></b-form-input> <br />
          <b-form-input v-model="form.email" placeholder="Email"></b-form-input> <br />
          <b-form-input v-model="form.phone" placeholder="Phone (Optional)"></b-form-input> <br />
          <b-form-textarea
            id="textarea"
            v-model="form.message"
            placeholder="Your message..."
            rows="3"
            max-rows="6"
          ></b-form-textarea> <br />
          <b-button type="submit">Submit</b-button>
        </b-form>
        <div v-if="thanks">
          <p>Your message was sent.</p>
          <p>Thank you!</p>
          <p>We will be in touch.</p>
          <p>-- URBNRX</p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      show: true,
      thanks: false,
    };
  },
  methods: {
    send(evt) {
      evt.preventDefault();
      this.show = false;
      this.thanks = true;
      const data = JSON.stringify(this.form);
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Access-Control': 'Allow-Origin' },
        body: data,
      };
      const res = fetch('https://3gv5dx6whg.execute-api.us-east-1.amazonaws.com/prod/contact', requestOptions)
        .then((response) => console.log(response.body));
      console.log(data);
      console.log('========================');
    },
  },
};
</script>
<style lang="scss">
  label{
    .label{
      display: inline-block;
      width: 10rem;
    }
    .required{
      font-size: 1rem;
      color: orange;
    }
  }
</style>
